<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card sm:w-4/5 relative">
      <button class="system-button ml-auto" @click.prevent="$emit('close')">
        <close-icon class="w-8 fill-current" />
      </button>

      <form class="" @submit.prevent="save">
        <p class="font-medium mt-4 mb-2">Comidas</p>

        <button
          v-if="form.meals.length < 7"
          class="secondary-button mb-2"
          @click.prevent="createMeal()"
        >
          Crear Comida
        </button>

        <div
          v-for="(meal, i) in form.meals"
          :key="i"
          class="card mb-4 border border-secondary-500"
        >
          <p class="medium">Comida #{{ i + 1 }}</p>
          <button class="secondary-button" @click.prevent="createPortion(i)">
            Crear Porción
          </button>

          <div
            v-for="(portion, j) in meal.portions"
            :key="j"
            class="card mt-4 border border-tertiary-500"
          >
            <p class="medium">Porción #{{ j + 1 }}</p>

            <div v-if="!form.meals[i].portions[j].saved">
              <div class="flex flex-col w-full">
                <label for="category">Categoría</label>
                <select
                  id="category"
                  v-model="form.meals[i].portions[j].diet_category_id"
                  @change="form.meals[i].portions[j].diet_subcategory_id = null"
                >
                  <option :value="null" selected>Seleccionar</option>
                  <option
                    v-for="category in dietCategories"
                    :key="category.id"
                    :value="category.id"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </div>

              <div class="flex flex-col w-full mt-4">
                <label for="subcategory">Subcategoría</label>
                <select
                  id="subcategory"
                  v-model="form.meals[i].portions[j].diet_subcategory_id"
                  :disabled="
                    form.meals[i].portions[j].diet_category_id === null
                  "
                >
                  <option :value="null" selected>Seleccionar</option>
                  <option
                    v-for="subcategory in getSubCategories(
                      form.meals[i].portions[j].diet_category_id
                    )"
                    :key="subcategory.id"
                    :value="subcategory.id"
                  >
                    {{ subcategory.name }}
                  </option>
                </select>
              </div>

              <div class="flex flex-col w-full mt-4">
                <label for="quantity">Cantidad (gramos)</label>
                <input
                  id="quantity"
                  type="number"
                  step="any"
                  v-model="form.meals[i].portions[j].quantity"
                />
                <validation-errors
                  :errors="errorFor('quantity')"
                ></validation-errors>
              </div>

              <button
                class="secondary-button mt-4"
                @click.prevent="savePortion(i, j)"
              >
                Guardar Porción
              </button>

              <button
                class="delete-button mt-2 block"
                @click.prevent="form.meals[i].portions.splice(j, 1)"
              >
                Eliminar
              </button>
            </div>

            <div v-else>
              <div class="mt-1 text-sm">
                <p class="font-medium">Categoría</p>
                <p>
                  {{
                    getCategoryName(form.meals[i].portions[j].diet_category_id)
                  }}
                </p>
              </div>

              <div class="mt-1 text-sm">
                <p class="font-medium">Subcategoría</p>
                <p>
                  {{
                    getSubCategoryName(
                      form.meals[i].portions[j].diet_subcategory_id
                    )
                  }}
                </p>
              </div>

              <div class="mt-1 text-sm">
                <p class="font-medium">Cantidad</p>
                <p>{{ form.meals[i].portions[j].quantity }}g</p>
              </div>

              <button
                class="cancel-button mt-2 block"
                @click.prevent="form.meals[i].portions[j].saved = false"
              >
                Editar
              </button>

              <button
                class="delete-button mt-2 block"
                @click.prevent="form.meals[i].portions.splice(j, 1)"
              >
                Eliminar
              </button>
            </div>
          </div>

          <!-- <div class="flex flex-col w-full mt-4">
            <label for="comments">Comentarios</label>
            <textarea
              class="h-28"
              id="comments"
              type="text"
              v-model="form.meals[i].comments"
            />
          </div> -->

          <button
            v-if="canDuplicate(i)"
            class="cancel-button mt-2 block"
            @click.prevent="duplicateMeal(i)"
          >
            Duplicar
          </button>

          <button
            class="delete-button mt-2 block"
            @click.prevent="form.meals.splice(i, 1)"
          >
            Eliminar
          </button>
        </div>

        <div v-if="mealsCompleted" @submit.prevent="updateMealSet">
          <!-- <div class="flex flex-col w-full mt-4">
            <label for="comments">Comentarios</label>
            <textarea
              class="h-28"
              id="comments"
              type="text"
              v-model="form.comments"
            />
          </div> -->

          <primary-button class="mx-0 mt-4" :loading="loading" type="submit"
            >Guardar</primary-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CloseIcon from "@/icons/CloseIcon";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Meal Set Form",

  components: {
    CloseIcon,
  },

  data() {
    return {
      loading: false,
      form: {
        meals: [],
      },
    };
  },

  props: {
    dietCategories: Array,
    dietStages: Array,
    dietTypes: Array,
    mealSet: Object,
  },

  computed: {
    mealsCompleted() {
      if (this.form.meals.length !== 7) {
        return false;
      }

      for (let meal of this.form.meals) {
        if (meal.portions.length === 0) {
          return false;
        }

        for (let portion of meal.portions) {
          if (!portion.saved) {
            return false;
          }
        }
      }

      return true;
    },
  },

  mixins: [validationErrors],

  created() {
    this.form = JSON.parse(
      JSON.stringify(this.prepareMealSetFormat(this.mealSet))
    );
  },

  methods: {
    close() {
      this.$emit("close");
    },

    prepareMealSetFormat(mealSet) {
      let mealSetFormatted = JSON.parse(JSON.stringify(mealSet));

      mealSetFormatted.meals.forEach((meal) => {
        meal.portions.forEach((portion) => {
          portion.diet_category_id = portion.diet_subcategory.diet_category_id;
          portion.saved = true;

          delete portion.id;
          delete portion.meal_id;
          delete portion.meal_id;
          delete portion.diet_subcategory;
          delete portion.created_at;
          delete portion.updated_at;
        });

        delete meal.id;
        delete meal.diet_id;
        delete meal.created_at;
        delete meal.updated_at;
      });

      delete mealSetFormatted.collapsed;
      delete mealSetFormatted.created_at;
      delete mealSetFormatted.updated_at;
      delete mealSetFormatted.diet_stage;
      delete mealSetFormatted.diet_type;
      delete mealSetFormatted.quote_id;

      return mealSetFormatted;
    },

    createMeal() {
      this.form.meals.push({
        portions: [],
        comments: "",
      });
    },

    createPortion(index) {
      this.form.meals[index].portions.push({
        quantity: null,
        diet_category_id: null,
        diet_subcategory_id: null,
      });
    },

    savePortion(categoryIndex, subcategoryIndex) {
      const portion = this.form.meals[categoryIndex].portions[subcategoryIndex];

      if (!portion.quantity || portion.diet_subcategory_id === null) {
        this.$store.dispatch(
          "errorSnack",
          "Es necesario llenar todos los campos"
        );
        return;
      }

      this.form.meals[categoryIndex].portions[subcategoryIndex].saved = true;
    },

    canDuplicate(categoryIndex) {
      if (
        this.form.meals[categoryIndex].portions.length === 0 ||
        this.form.meals.length >= 7
      ) {
        return false;
      }

      for (let portion of this.form.meals[categoryIndex].portions) {
        if (!portion.saved) {
          return false;
        }
      }

      return true;
    },

    duplicateMeal(categoryIndex) {
      const meal = JSON.parse(JSON.stringify(this.form.meals[categoryIndex]));

      this.form.meals.push(meal);
    },

    getSubCategories(categoryId) {
      if (categoryId === null) {
        return [];
      }

      var subcategories = [];

      this.dietCategories.forEach((category) => {
        if (category.id === categoryId) {
          subcategories = category.diet_subcategories;
        }
      });

      return subcategories;
    },

    getCategoryName(id) {
      return this.dietCategories.filter((category) => category.id === id)[0]
        .name;
    },

    getSubCategoryName(id) {
      for (let category of this.dietCategories) {
        for (let subcategory of category.diet_subcategories) {
          if (subcategory.id === id) {
            return subcategory.name;
          }
        }
      }
      return null;
    },

    save() {
      // if (!this.validateForm()) {
      //   this.$store.dispatch(
      //     "errorSnack",
      //     "Favor de llenar todos los campos correctamente."
      //   );
      //   return;
      // }

      this.updateMealSet();
    },

    validateForm() {
      this.errors = {};

      return Object.keys(this.errors).length === 0;
    },

    async updateMealSet() {
      this.loading = true;

      try {
        const response = await api.mealSets.update(this.mealSet.id, this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$emit("updated");
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },
  },
};
</script>